import styled from 'styled-components'

export const Container = styled.div`
  width: 85%;
  max-width: 1640px;
  margin: 0 auto;
`

export const ContainerSmall = styled.div`
  max-width: 900px;
  margin: 0 auto;
`
